import React, { useEffect, useRef, useState } from "react";
import {
  _addUserInChatList,
  _getAllChats,
  _getChatMessages,
  _getGroupChatList,
} from "src/DAL";
import ChatHeader from "./ChatHeader";
import MessageContainer from "./MessageContainer";
import { useAppContext } from "src/hooks";
import { useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function ShowSingleChat({
  chatList,
  currentChat,
  setCurrentChat,
  setChatListDrawerOpen,
  messageCount,
  loadMoreMessages,
  isMobile,
  onLastMassageView,
  handleAddNewChat,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { isOpenChatDialog, isMinimizeChat } = useAppContext();
  const { pathname } = useLocation();
  const [isDraggingFiles, setIsDraggingFiles] = useState(false);
  const [chatFile, setChatFile] = useState();

  function handleDragOver(e) {
    e.preventDefault();
    setIsDraggingFiles(true);
  }

  function handleDragLeave(e) {
    e.preventDefault();
    setIsDraggingFiles(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    setIsDraggingFiles(false);

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type.startsWith("image/")) {
        console.log("Image file dropped:", file);
        setChatFile(file);
      } else {
        console.log("Not an image file:", file);
        enqueueSnackbar("Only Images are allowed", { variant: "warning" });
      }
    }
  }

  return (
    <div
      className={`${
        isOpenChatDialog
          ? "col-12 chat-messages"
          : !isMobile
          ? "col-9 chat-messages"
          : "col-12 chat-messages-full"
      } common-border`}
    >
      <div
        className="chat-container-wrapper"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {isDraggingFiles && (
          <div className="drop-overlay">
            <span>Drop files here</span>
          </div>
        )}
        <div className="full-chat-container">
          <ChatHeader
            chatList={chatList}
            isMobile={isMobile}
            currentChat={currentChat}
            setCurrentChat={setCurrentChat}
            setChatListDrawerOpen={setChatListDrawerOpen}
            handleAddNewChat={handleAddNewChat}
          />
          {(!isMinimizeChat || pathname.startsWith("/chats")) && (
            <MessageContainer
              messageCount={messageCount}
              loadMoreMessages={loadMoreMessages}
              currentChat={currentChat}
              onLastMassageView={onLastMassageView}
              handleAddNewChat={handleAddNewChat}
              chatFile={chatFile}
              setChatFile={setChatFile}
            />
          )}
        </div>
      </div>
    </div>

    // <div className={`${isOpenChatDialog ? "col-12 chat-messages" : !isMobile ? "col-9 chat-messages" : "col-12 chat-messages-full"} common-border`}>
    // <div className="full-chat-container">
    //     <ChatHeader
    //         chatList={chatList}
    //         isMobile={isMobile}
    //         currentChat={currentChat}
    //         setCurrentChat={setCurrentChat}
    //         setChatListDrawerOpen={setChatListDrawerOpen}
    //         handleAddNewChat={handleAddNewChat}
    //     />
    //     {(!isMinimizeChat || pathname == "/chats") && <MessageContainer
    //         loadingMessageList={loadingMessageList}
    //         messageCount={messageCount}
    //         loadMoreMessages={loadMoreMessages}
    //         currentChat={currentChat}
    //         onLastMassageView={onLastMassageView}
    //         handleAddNewChat={handleAddNewChat}
    //     />}
    // </div>
    // </div>
  );
}
